<app-modal-title>{{getTitle()}}</app-modal-title>
<app-modal-body>
    <div class="ot-panel">
        <app-tabs [identifier]="'instance-details-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs" [color]="TabColor.PRIMARY" [selectedIndex]="activeTab"></app-tabs>
        <ng-scrollbar style="height: 380px">
            <div [ngClass]="{'ot-panel__body ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-1': activeTab == InstanceTab.OVERVIEW}">
                @if(activeTab == InstanceTab.OVERVIEW){
                <div class="otsc-metadata" tabindex="0">
                    @for(prop of properties; track prop){
                    <div class="ot-row">
                        <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted">{{prop.name}}</small>
                        </div>
                        <div class="ot-row__column otsc-metadata-value">
                        @switch(prop.key){
                        @case('isMasterSystem'){
                            @if(instanceMetaData[prop.key]){
                            <p i18n>Yes</p>
                            } @else {
                            <p i18n>No</p>
                            }
                        }
                        @default {
                        <p>{{instanceMetaData[prop.key]}}</p>
                        }
                        }
                        </div>
                    </div>
                    }
                    @if(instanceMetaData.extraInfo){
                    @for(prop of extraProperties; track prop){
                    <div class="ot-row">
                        <div class="ot-row__column otsc-metadata-key">
                            <small class="ot--has-text-muted">{{prop.name}}</small>
                        </div>
                        <div class="ot-row__column otsc-metadata-value">
                            @switch(prop.key){
                            @case('patches'){
                            <p>{{instanceMetaData.extraInfo[prop.key] ? instanceMetaData.extraInfo[prop.key].join(", ") : ''}}</p>
                            }
                            @default {
                            <p>{{instanceMetaData.extraInfo[prop.key]}}</p>
                            }
                            }
                        </div>
                    </div>
                    }
                    }
                </div>
                }
                @if(activeTab == InstanceTab.MODULES){
                <div [ngStyle]="{'height': '420px'}">
                    <ng-scrollbar>
                        @if(instanceMetaData.extraInfo && instanceMetaData.extraInfo.modules && instanceMetaData.extraInfo.modules.length > 0){
                        <ul class="ot-list ot-list--is-high-density ot-pt-1" tabindex="0">
                            @for(module of instanceMetaData.extraInfo.modules; track module){
                            <li class="ot-list ot-list--is-high-density" tabindex="-1" class="ot-list__item" >
                                <span>{{module.name + ' ' + module.version}}</span>
                            </li>
                            }
                        </ul>
                        } @else {
                        <ng-template #noModules>
                            <div class="otsc-no-items__icon"></div>
                            <div class="otsc-no-items__text" i18n>
                                There are no items to display.
                            </div>
                        </ng-template>
                        }
                    </ng-scrollbar>
                </div>
                }
            </div>
        </ng-scrollbar>
    </div>
</app-modal-body>
<app-modal-footer>
    <button class="ot-btn ot-btn--is-primary" i18n-title title="Close" (click)="close()" i18n>
        Close
    </button>
</app-modal-footer>